import TextFieldMui from 'src/components/TextFieldMui'
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: start;
  margin-top: 1.5rem;
`

export const ContainerTitle = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: start;
  gap: 1.5rem;
`

export const LocalPrinterInfosContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const LocalPrinterInfosSubContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1.5rem;
  width: 100%;
`

export const CustomTextField = styled(TextFieldMui)`
`
